module.exports = __webpack_public_path__ + "static/12-59f9f318931366c00c116906b95dfb04.jpg";